import { render, staticRenderFns } from "./relatorioEnviosClientes.vue?vue&type=template&id=0bcb6aea"
import script from "./relatorioEnviosClientes.vue?vue&type=script&lang=js"
export * from "./relatorioEnviosClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports